import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';
import { getFullRoutePath } from '@/router/utils/getFullRoutePath';

export const ERZ_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.ERZ> | 'WEAPON_REGISTERED', RouteConfig> = {
  COMMISSION_SALE: { basePath: config.router.servicePath, path: 'commission-sale', isPrivate: true },
  COLD_STEEL_TRANSPORTATION: {
    basePath: config.router.servicePath,
    path: 'collectable-cold-weapons-transportation',
    isPrivate: true,
  },
  PURCHASE: { basePath: config.router.servicePath, path: 'weapon-purchase-permit', isPrivate: true },
  RESIDENCE_RELOCATION: { basePath: config.router.servicePath, path: 'residence-relocation', isPrivate: true },
  TEMPORARY_RESIDENCE_RELOCATION: {
    basePath: config.router.servicePath,
    path: 'temporary-residence-relocation',
    isPrivate: true,
  },
  TRANSPORT_ACROSS_BORDER: { basePath: config.router.servicePath, path: 'weapon-transportation', isPrivate: true },
  STORAGE_CARRYING: { basePath: config.router.servicePath, path: 'weapon-storage-carrying', isPrivate: true },
  VALIDITY_PERIOD_PROLONGATION: { basePath: config.router.servicePath, path: 'permission-renewal', isPrivate: true },
  COLD_STEEL_STORAGE_FOR_COLLECTION: {
    basePath: config.router.servicePath,
    path: 'cold-steel-storage-for-collection',
    isPrivate: true,
  },
  CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION: {
    basePath: config.router.servicePath,
    path: 'cancellation-temporary-residence-relocation',
    isPrivate: true,
  },
  ERZ_EXTRACT: { basePath: config.router.userPath, path: 'erz-extract', isPrivate: true },
  ERZ_SEARCH: { basePath: config.router.servicePath, path: 'erzsearch', isPrivate: false },
  WEAPON_REGISTERED: { basePath: config.router.userPath, path: 'weapon-registered', isPrivate: true },
  REAPPLICATION: { basePath: config.router.servicePath, path: 'reapplication', isPrivate: true },
};

export const ERZ_PATHS_LEGACY = [
  {
    LEGACY_PATH: '/erzsearch',
    RELEVANT_PATH: getFullRoutePath(IntegrationSystem.ERZ, ERZ_ROUTES.ERZ_SEARCH),
  },
];
